import { render, staticRenderFns } from "./NewsletterUnsubscribe.vue?vue&type=template&id=40c3a375"
import script from "./NewsletterUnsubscribe?vue&type=script&lang=ts&external"
export * from "./NewsletterUnsubscribe?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports